// Stripe Payment Links - Create these in your Stripe Dashboard
// Dashboard > Payment Links > Create a payment link
// These are direct URLs that open Stripe's hosted checkout page

export const STRIPE_PAYMENT_LINKS = {
  pro_monthly: 'https://buy.stripe.com/7sY14ngzZbThfbO8Hj5Vu00', // Replace with your actual Stripe Payment Link
  pro_annual: 'https://buy.stripe.com/bJe6oH0B1aPdd3GaPr5Vu01',   // Replace with your actual Stripe Payment Link
};

export const STRIPE_PRODUCTS = {
  pro_monthly: {
    name: 'TheNextlete Pro - Monthly',
    amount: '$12',
    period: '/month',
    paymentLink: STRIPE_PAYMENT_LINKS.pro_monthly,
  },
  pro_annual: {
    name: 'TheNextlete Pro - Annual',
    amount: '$99',
    period: '/year',
    savings: 'Save 30%',
    paymentLink: STRIPE_PAYMENT_LINKS.pro_annual,
  },
};

export const redirectToStripeCheckout = (plan, userEmail, userId) => {
  const product = STRIPE_PRODUCTS[plan];
  if (!product?.paymentLink) {
    throw new Error('Payment link not configured. Please set up Stripe Payment Links.');
  }

  // Build the payment link URL with prefilled email and metadata
  const successUrl = encodeURIComponent(`${window.location.origin}/#/settings?tab=subscription&success=true`);
  const cancelUrl = encodeURIComponent(`${window.location.origin}/#/settings?tab=subscription&cancelled=true`);

  // Append query params to payment link
  let checkoutUrl = product.paymentLink;
  const params = new URLSearchParams();
  if (userEmail) params.append('prefilled_email', userEmail);
  params.append('client_reference_id', userId || '');

  const paramString = params.toString();
  if (paramString) {
    checkoutUrl += (checkoutUrl.includes('?') ? '&' : '?') + paramString;
  }

  // Redirect to Stripe hosted checkout
  window.location.href = checkoutUrl;
};